<app-theme-option [categories]="['SERIE']" [label]="'VALUES'" [information]="$studio.valuesPerSeries + ''">
  <div app-theme-option-content>
    <app-slider [color]="color" [value]="$studio.valuesPerSeries" (sendValue)="receiveValuePerSeries($event)" [min]="5" [max]="20"></app-slider>
  </div>
</app-theme-option>